import { SimpleChanges } from '@angular/core';
import { QuestionarreAnswerService } from '../../../entities/questionarre-answer/questionarre-answer.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LookingForHelpTopicsService } from '../../../entities/looking-for-help-topics/looking-for-help-topics.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../entities/questionarre-answer/questionarre-answer.service";
import * as i2 from "../../../entities/looking-for-help-topics/looking-for-help-topics.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "@angular/common";
import * as i5 from "@fortawesome/angular-fontawesome";
import * as i6 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i7 from "../wellbeing-result-body-chart/wellbeing-result-body-chart.component";
import * as i8 from "../wellbeing-result-mood-chart/wellbeing-result-mood-chart.component";
import * as i9 from "../wellbeing-result-energy-chart/wellbeing-result-energy-chart.component";
import * as i10 from "../wellbeing-result-purpose-chart/wellbeing-result-purpose-chart.component";
function WellbeingResultDetailsComponent_div_0_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 23);
} }
function WellbeingResultDetailsComponent_div_0_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 24);
} }
function WellbeingResultDetailsComponent_div_0_span_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 25);
} }
function WellbeingResultDetailsComponent_div_0_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 27);
    i0.ɵɵelement(2, "use", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Client answered \u201CYes\u201D to question 17 ");
    i0.ɵɵelementEnd();
} }
function WellbeingResultDetailsComponent_div_0_div_31_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const helpTopic_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", helpTopic_r11, " ");
} }
function WellbeingResultDetailsComponent_div_0_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵtext(3, " Topics that the user would like support with: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 31);
    i0.ɵɵtemplate(5, WellbeingResultDetailsComponent_div_0_div_31_span_5_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r5.helpTopics);
} }
function WellbeingResultDetailsComponent_div_0_div_32_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 43);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const answer_r13 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", answer_r13.questionId, ". ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "inukaNgApp.selfScan.q", answer_r13.questionId - 1, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(answer_r13.answer);
} }
function WellbeingResultDetailsComponent_div_0_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "wellbeing-result-body-chart", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵelementStart(4, "div", 38);
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵelementStart(6, "h5", 39);
    i0.ɵɵtext(7, "Body");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, WellbeingResultDetailsComponent_div_0_div_32_div_8_Template, 6, 3, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("testResult", ctx_r6.selectedSrq);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r6.srqBodyAnswers);
} }
function WellbeingResultDetailsComponent_div_0_div_33_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 43);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const answer_r15 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", answer_r15.questionId, ". ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "inukaNgApp.selfScan.q", answer_r15.questionId - 1, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(answer_r15.answer);
} }
function WellbeingResultDetailsComponent_div_0_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "wellbeing-result-mood-chart", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵelementStart(4, "div", 38);
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵelementStart(6, "h5", 44);
    i0.ɵɵtext(7, "Mood");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, WellbeingResultDetailsComponent_div_0_div_33_div_8_Template, 6, 3, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("testResult", ctx_r7.selectedSrq);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r7.srqMoodAnswers);
} }
function WellbeingResultDetailsComponent_div_0_div_34_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 43);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const answer_r17 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", answer_r17.questionId, ". ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "inukaNgApp.selfScan.q", answer_r17.questionId - 1, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(answer_r17.answer);
} }
function WellbeingResultDetailsComponent_div_0_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵelement(2, "wellbeing-result-energy-chart", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵelementStart(4, "div", 38);
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵelementStart(6, "h5", 46);
    i0.ɵɵtext(7, "Energy");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, WellbeingResultDetailsComponent_div_0_div_34_div_8_Template, 6, 3, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("testResult", ctx_r8.selectedSrq);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r8.srqEnergyAnswers);
} }
function WellbeingResultDetailsComponent_div_0_div_35_div_8_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " N/A ");
    i0.ɵɵelementContainerEnd();
} }
function WellbeingResultDetailsComponent_div_0_div_35_div_8_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const answer_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", answer_r19.answer, " ");
} }
const _c0 = function (a0) { return { "text-danger font-weight-bold": a0 }; };
function WellbeingResultDetailsComponent_div_0_div_35_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 43);
    i0.ɵɵtemplate(5, WellbeingResultDetailsComponent_div_0_div_35_div_8_ng_container_5_Template, 2, 0, "ng-container", 49);
    i0.ɵɵtemplate(6, WellbeingResultDetailsComponent_div_0_div_35_div_8_ng_container_6_Template, 2, 1, "ng-container", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const answer_r19 = ctx.$implicit;
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, answer_r19.questionId === 17 && ctx_r18.hasAnsweredYesToQuetion17));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", answer_r19.questionId, ". ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "inukaNgApp.selfScan.q", answer_r19.questionId - 1, "");
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("text-danger", answer_r19.questionId === 17 && ctx_r18.hasAnsweredYesToQuetion17);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", answer_r19.answer === "NotAnswered");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", answer_r19.answer !== "NotAnswered");
} }
function WellbeingResultDetailsComponent_div_0_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "wellbeing-result-purpose-chart", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵelementStart(4, "div", 38);
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵelementStart(6, "h5", 47);
    i0.ɵɵtext(7, "Purpose");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, WellbeingResultDetailsComponent_div_0_div_35_div_8_Template, 7, 9, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("testResult", ctx_r9.selectedSrq);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r9.srqPurposeAnswers);
} }
function WellbeingResultDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "button", 4);
    i0.ɵɵlistener("click", function WellbeingResultDetailsComponent_div_0_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.showPrevious(); });
    i0.ɵɵtext(4, "< Previous");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 5);
    i0.ɵɵlistener("click", function WellbeingResultDetailsComponent_div_0_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.showNext(); });
    i0.ɵɵtext(6, "Next >\t");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵelementStart(8, "fa-icon", 7);
    i0.ɵɵlistener("click", function WellbeingResultDetailsComponent_div_0_Template_fa_icon_click_8_listener() { i0.ɵɵrestoreView(_r24); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 6);
    i0.ɵɵelementStart(14, "fa-icon", 10);
    i0.ɵɵlistener("click", function WellbeingResultDetailsComponent_div_0_Template_fa_icon_click_14_listener() { i0.ɵɵrestoreView(_r24); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 11);
    i0.ɵɵelementStart(16, "div", 12);
    i0.ɵɵelementStart(17, "h5", 13);
    i0.ɵɵtext(18, "Client result: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 14);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "h5", 15);
    i0.ɵɵtemplate(22, WellbeingResultDetailsComponent_div_0_span_22_Template, 1, 0, "span", 16);
    i0.ɵɵtemplate(23, WellbeingResultDetailsComponent_div_0_span_23_Template, 1, 0, "span", 17);
    i0.ɵɵtemplate(24, WellbeingResultDetailsComponent_div_0_span_24_Template, 1, 0, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, WellbeingResultDetailsComponent_div_0_div_25_Template, 4, 0, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 20);
    i0.ɵɵelementStart(27, "button", 4);
    i0.ɵɵlistener("click", function WellbeingResultDetailsComponent_div_0_Template_button_click_27_listener() { i0.ɵɵrestoreView(_r24); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.showPrevious(); });
    i0.ɵɵtext(28, "< Previous");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "button", 5);
    i0.ɵɵlistener("click", function WellbeingResultDetailsComponent_div_0_Template_button_click_29_listener() { i0.ɵɵrestoreView(_r24); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.showNext(); });
    i0.ɵɵtext(30, "Next >\t");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, WellbeingResultDetailsComponent_div_0_div_31_Template, 6, 1, "div", 21);
    i0.ɵɵtemplate(32, WellbeingResultDetailsComponent_div_0_div_32_Template, 9, 2, "div", 22);
    i0.ɵɵtemplate(33, WellbeingResultDetailsComponent_div_0_div_33_Template, 9, 2, "div", 22);
    i0.ɵɵtemplate(34, WellbeingResultDetailsComponent_div_0_div_34_Template, 9, 2, "div", 22);
    i0.ɵɵtemplate(35, WellbeingResultDetailsComponent_div_0_div_35_Template, 9, 2, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !(ctx_r0.selectedSrqIndex > 0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !(ctx_r0.selectedSrqIndex < ctx_r0.srqHistory.length - 1));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(12, 21, ctx_r0.selectedSrq == null ? null : ctx_r0.selectedSrq.dateTaken, "HH:mm, d MMM yyyy"), " ");
    i0.ɵɵadvance(8);
    i0.ɵɵclassProp("bg-danger", ctx_r0.isAtTough)("bg-warning", ctx_r0.isAtRisk)("bg-success", ctx_r0.isResilient);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.totalScore);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtTough);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtRisk);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isResilient);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasAnsweredYesToQuetion17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !(ctx_r0.selectedSrqIndex > 0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !(ctx_r0.selectedSrqIndex < ctx_r0.srqHistory.length - 1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.helpTopics && ctx_r0.helpTopics.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.srqBodyAnswers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.srqMoodAnswers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.srqEnergyAnswers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.srqPurposeAnswers);
} }
export class WellbeingResultDetailsComponent {
    constructor(questionarreAnswerService, lookingForHelpTopicsService, modalService) {
        this.questionarreAnswerService = questionarreAnswerService;
        this.lookingForHelpTopicsService = lookingForHelpTopicsService;
        this.modalService = modalService;
    }
    set selectedSrq(value) {
        var _a;
        if ((value === null || value === void 0 ? void 0 : value.id) !== ((_a = this._selectedSrq) === null || _a === void 0 ? void 0 : _a.id)) {
            this._selectedSrq = value;
            this.determineTotalScoreStage(value.score);
            this.fetchSrqAnswers();
        }
    }
    get selectedSrq() {
        return this._selectedSrq;
    }
    ngOnChanges(changes) {
        this.findSelectedSrqIndex();
    }
    findSelectedSrqIndex() {
        if (this.selectedSrq && this.srqHistory) {
            this.selectedSrqIndex = this.srqHistory.findIndex(srq => srq.id === this.selectedSrq.id);
            this.loadHelpTopics();
        }
    }
    ngOnInit() {
        this.findSelectedSrqIndex();
    }
    determineTotalScoreStage(totalScore) {
        this.totalScore = totalScore;
        this.isAtRisk = false;
        this.isAtTough = false;
        this.isResilient = false;
        if (totalScore <= 3) {
            this.isAtTough = true;
        }
        else if (totalScore >= 4 && totalScore <= 13) {
            this.isAtRisk = true;
        }
        else if (totalScore >= 14) {
            this.isResilient = true;
        }
    }
    fetchSrqAnswers() {
        this.questionarreAnswerService.findBySrqId(this.selectedSrq.id).subscribe(res2 => {
            this.groupAnswers(res2.body);
        });
    }
    groupAnswers(answers) {
        this.srqBodyAnswers = [];
        this.srqEnergyAnswers = [];
        this.srqMoodAnswers = [];
        this.srqPurposeAnswers = [];
        this.hasAnsweredYesToQuetion17 = false;
        if (answers && answers.length) {
            answers.forEach(answer => {
                if (answer.questionId >= 1 && answer.questionId <= 6) {
                    this.srqBodyAnswers.push(answer);
                }
                else if (answer.questionId >= 7 && answer.questionId <= 10) {
                    this.srqMoodAnswers.push(answer);
                }
                else if (answer.questionId >= 11 && answer.questionId <= 16) {
                    this.srqEnergyAnswers.push(answer);
                }
                else if (answer.questionId >= 17 && answer.questionId <= 20) {
                    this.srqPurposeAnswers.push(answer);
                    if (answer.questionId === 17 && answer.answer === 'Yes') {
                        this.hasAnsweredYesToQuetion17 = true;
                    }
                }
            });
        }
    }
    loadHelpTopics() {
        const isFirstSrqCompletedSelected = this.srqHistory && this.selectedSrqIndex === 0;
        this.helpTopics = null;
        if (isFirstSrqCompletedSelected) {
            this.lookingForHelpTopicsService.getUserLookingForHelpTopics(this.selectedSrq.user.id).subscribe(response => {
                var _a;
                if (response.ok && ((_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.length)) {
                    const userLookingForHelpTopics = response.body;
                    // we used to show the user's answer to the looking for help topics along with the first self scan
                    // trying to do the same while users can have more than one list of looking for help topics
                    const firstLookingForHelpTopics = userLookingForHelpTopics[0];
                    this.helpTopics = firstLookingForHelpTopics.topics;
                }
            });
        }
    }
    showNext() {
        if (this.selectedSrqIndex < this.srqHistory.length - 1) {
            this.selectedSrqIndex++;
            this.selectedSrq = this.srqHistory[this.selectedSrqIndex];
            this.loadHelpTopics();
        }
    }
    showPrevious() {
        if (this.selectedSrqIndex > 0) {
            this.selectedSrqIndex--;
            this.selectedSrq = this.srqHistory[this.selectedSrqIndex];
            this.loadHelpTopics();
        }
    }
    close() {
        this.modalService.dismissAll();
    }
}
WellbeingResultDetailsComponent.ɵfac = function WellbeingResultDetailsComponent_Factory(t) { return new (t || WellbeingResultDetailsComponent)(i0.ɵɵdirectiveInject(i1.QuestionarreAnswerService), i0.ɵɵdirectiveInject(i2.LookingForHelpTopicsService), i0.ɵɵdirectiveInject(i3.NgbModal)); };
WellbeingResultDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingResultDetailsComponent, selectors: [["wellbeing-result-details"]], inputs: { selectedSrq: "selectedSrq", srqHistory: "srqHistory" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "olha-theme p-4", "style", "height: 80vh;overflow-y: scroll;overflow-x: hidden;", 4, "ngIf"], [1, "olha-theme", "p-4", 2, "height", "80vh", "overflow-y", "scroll", "overflow-x", "hidden"], [1, "row", "justify-content-around", "d-lg-none", "pb-4"], [1, "col"], [1, "mr-3", "btn", "btn-link", "text-light", 3, "disabled", "click"], [1, "btn", "btn-link", "text-light", 3, "disabled", "click"], [1, "col", "text-right"], ["icon", "times-circle", 2, "cursor", "pointer", 3, "click"], [1, "row", "justify-content-around"], [1, "col", "text-light"], ["icon", "times-circle", 1, "d-none", "d-lg-inline-block", 2, "cursor", "pointer", 3, "click"], [1, "row", "mt-4", "pb-2", 2, "border-bottom", "1px solid #DFF1EC"], [1, "col-12", "col-lg-9"], [1, "d-inline-block"], [1, "text-white", "p-1", "ml-2", "font-weight-bold", 2, "border-radius", "5px", "width", "1.5rem", "height", "1.5rem", "display", "inline-block", "text-align", "center", "line-height", "1rem"], [1, "d-inline-block", "mx-2"], ["class", "h6 text-danger", "jhiTranslate", "wellBeingResult.stages.atTough.title", 4, "ngIf"], ["class", "h6 text-warning", "jhiTranslate", "wellBeingResult.stages.atRisk.title", 4, "ngIf"], ["class", "h6 text-success", "jhiTranslate", "wellBeingResult.stages.resilient.title", 4, "ngIf"], ["class", "d-lg-inline-block text-danger", 4, "ngIf"], [1, "col", "col-lg-3", "d-none", "d-lg-block", "text-right"], ["class", "row mt-4 pb-3", "style", "border-bottom: 1px solid #DFF1EC", 4, "ngIf"], ["class", "row mt-4", 4, "ngIf"], ["jhiTranslate", "wellBeingResult.stages.atTough.title", 1, "h6", "text-danger"], ["jhiTranslate", "wellBeingResult.stages.atRisk.title", 1, "h6", "text-warning"], ["jhiTranslate", "wellBeingResult.stages.resilient.title", 1, "h6", "text-success"], [1, "d-lg-inline-block", "text-danger"], [2, "height", "14px", "width", "14px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#exclamation-circle"], [1, "row", "mt-4", "pb-3", 2, "border-bottom", "1px solid #DFF1EC"], [1, "text-light"], [1, "mt-3"], ["class", "help-topic-badge", 4, "ngFor", "ngForOf"], [1, "help-topic-badge"], [1, "row", "mt-4"], [1, "col-12", "col-lg-6", "pt-4", "pt-lg-0", "order-lg-1"], [3, "testResult"], [1, "col-12", "col-lg-6", "order-lg-0"], [1, "row"], ["jhiTranslate", "inukaNgApp.selfScan.body"], ["class", "row justify-content-around", 4, "ngFor", "ngForOf"], [1, "col-10"], [3, "jhiTranslate"], [1, "col-2", "font-weight-bold"], ["jhiTranslate", "inukaNgApp.selfScan.mood"], [1, "col-12", "col-lg-6", "pt-4", "order-lg-1"], ["jhiTranslate", "inukaNgApp.selfScan.energy"], ["jhiTranslate", "inukaNgApp.selfScan.purpose"], [1, "col-10", 3, "ngClass"], [4, "ngIf"]], template: function WellbeingResultDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, WellbeingResultDetailsComponent_div_0_Template, 36, 24, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedSrq);
    } }, directives: [i4.NgIf, i5.FaIconComponent, i6.JhiTranslateDirective, i4.NgForOf, i7.WellbeingResultBodyChartComponent, i8.WellbeingResultMoodChartComponent, i9.WellbeingResultEnergyChartComponent, i10.WellbeingResultPurposeChartComponent, i4.NgClass], pipes: [i4.DatePipe], styles: [".progress[_ngcontent-%COMP%]{background-color:#e1e1e1}.progress-bar-horizontal-dela[_ngcontent-%COMP%]{width:100%;text-align:center;z-index:130;border-radius:8px}.progress-bar[_ngcontent-%COMP%]{z-index:120}.s-resilient-details[_ngcontent-%COMP%]{background-color:#a9d3c7;color:#000}.help-topic-badge[_ngcontent-%COMP%]{background-color:#dff1ec;border-radius:20px;color:#44a38b;padding:10px 20px;margin-right:20px;display:inline-block}.btn-link[_ngcontent-%COMP%]{text-decoration:none;font-weight:normal}"] });
